import script from "./Chead.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chead.vue?vue&type=script&setup=true&lang=ts"

import "./Chead.vue?vue&type=style&index=0&id=ab20a284&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab20a284"]])

export default __exports__